import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { getUser } from '../../../Auth/AuthReducer';
import piPermissions from '../../../../components/pi-permission';
import { fetchPIUser, fetchPIUserOrganizations } from '../../AdminActions';
import { getViewPIUser, getViewPIUserOrganizations } from '../../AdminReducer';
import ProgressBar from '../../../../components/progress-bar';
import UserOrganizationRow from '../../components/UserOrganizationRow/UserOrganizationRow';
import OrganizationAssignButton from '../../components/OrganizationAssignButton/OrganizationAssignButton';
import { Pagination } from 'react-bootstrap';

class PIUserDetailPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      errors: null,
      loadingOrganizations: false,
      organizationErrors: null,
    };
    this.handlePageSelect = this.handlePageSelect.bind(this);
  }
  componentDidMount() {
    this.syncUser(this.props.match.params.userID);
    this.syncOrganizations(this.props.match.params.userID);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.userID !== this.props.match.params.userID) {
      this.syncUser(nextProps.match.params.userID);
      this.syncOrganizations(nextProps.match.params.userID);
    } else if (nextProps.piUser.role === 'superadmin' || nextProps.piUser.role === 'admin') {
      const r = nextProps.piUser.role === 'superadmin' ? 'a Super Admin' : 'an Admin';
      const el = (<div>
        <strong>{nextProps.piUser.display_name}</strong> is {r}.<br />
        {nextProps.piUser.display_name} will have access to all organizations on TruSales.
      </div>);
      this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
      this.context.router.history.push('/admin/pi-users');
    } else if (nextProps.piUser._id && nextProps.piUser.role !== 'pi') {
      this.context.router.history.push('/admin/pi-users');
    }
  }

  syncUser(userID) {
    this.setState({ loading: true, errors: null });
    this.props.dispatch(fetchPIUser(userID))
      .then(
        () => {
          this.setState({ loading: false, errors: null });
        },
        (error) => {
          this.setState({ loading: false, errors: error.data || error });
          this.context.router.history.push('/admin/pi-users');
        },
      );
  }

  handlePageSelect(page) {
    this.syncOrganizations(this.props.match.params.userID, page);
  }

  syncOrganizations(userID, page = 1) {
    this.setState({ loadingOrganizations: true, organizationErrors: null });
    this.props.dispatch(fetchPIUserOrganizations(userID, { page }))
      .then(
        () => {
          this.setState({ loadingOrganizations: false, organizationErrors: null });
        },
        (error) => {
          this.setState({ loadingOrganizations: false, organizationErrors: error.data || error });
        },
      );
  }
  renderOrganizations() {
    const { loadingOrganizations, organizationErrors } = this.state;
    const { organizations: { items, meta: { pagination } }, piUser } = this.props;
    const v = true;
    return (
      <div>
        {loadingOrganizations && <div className="panel-body"><ProgressBar /></div>}
        {!loadingOrganizations && organizationErrors !== null && <div className="well">
          <div className="text-danger">{organizationErrors.message || 'Error loading organizations'}</div>
        </div>}
        {!loadingOrganizations && organizationErrors === null && items.length === 0 &&
          <div className="panel-body">
            <em>No organizations were assigned to {piUser.display_name}.</em>
          </div>}
        {!loadingOrganizations && organizationErrors === null && <div className="panel-body">
          <OrganizationAssignButton bsSize="xs" user={piUser} onAssign={() => { this.syncOrganizations(piUser._id); }} />
        </div>}
        {!loadingOrganizations && organizationErrors === null && <div>
          {items.length > 0 && <div>
            <div className="table-responsive">
              <table
                className="table table-hover table-condensed table-striped"
                style={{ margin: 0 }}
              >
                <tbody>
                  {items.map(item => (
                    <UserOrganizationRow
                      key={item._id}
                      organization={item}
                      user={piUser}
                      onDelete={() => { this.syncOrganizations(piUser._id); }}
                    />
                  ))}
                </tbody>
              </table>
            </div>
            {pagination && pagination.pages > 1 && <div className="text-center">
              <Pagination
                bsSize="small"
                boundaryLinks={v}
                next={v}
                prev={v}
                first={v}
                last={v}
                maxButtons={4}
                activePage={pagination.page}
                items={pagination.pages}
                onSelect={this.handlePageSelect}
              />
            </div>}
          </div>}
        </div>}
      </div>
    );
  }
  render() {
    const { loading, errors } = this.state;
    const { piUser } = this.props;
    const name = piUser ? piUser.name || piUser.display_name : '';
    return (
      <div>
        {!loading && errors !== null && <Helmet title={`${name} | Manage PI Users`} />}
        {loading && <ProgressBar />}
        {!loading && errors !== null && <div className="well">
          <div className="text-danger">{errors.message || 'Error loading user'}</div>
        </div>}
        {!loading && errors === null && <div className="panel panel-default" style={{ boxShadow: 'none', border: '1px solid #ccc' }}>
          <div className="panel-heading">
            <Link to="/admin/pi-users" className="close">&times;</Link>
            {name}
          </div>
          {this.renderOrganizations()}
        </div>}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
    piUser: getViewPIUser(state),
    organizations: getViewPIUserOrganizations(state),
  };
}

PIUserDetailPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  piUser: PropTypes.object.isRequired,
  organizations: PropTypes.shape({
    items: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
  }).isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  children: PropTypes.element,
};

PIUserDetailPage.contextTypes = {
  router: PropTypes.object,
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(piPermissions(PIUserDetailPage, 'superadmin', 'admin'));
